import { useEffect, useRef } from 'react';

type RefreshKey = string | number | boolean | undefined;

export const useAutoRefresh = (
  refresh: () => void | Promise<void>,
  delay = 10000,
  refreshKey?: RefreshKey
) => {
  const refreshRef = useRef(refresh);

  useEffect(() => {
    refreshRef.current = refresh;
  }, [refresh]);

  useEffect(() => {
    const run = () => {
      Promise.resolve(refreshRef.current()).catch((error) => {
        console.error('Auto refresh failed:', error);
      });
    };

    run();
    const intervalId = window.setInterval(run, delay);

    return () => window.clearInterval(intervalId);
  }, [delay, refreshKey]);
};
